@if (parent(); as parent) {
    <div class="px-4 py-3 flex w-full justify-between items-center">
        <div class="flex gap-1.5 items-center">
            <p class="text-sm text-gray-700">{{ parent.name }}</p>
            @if (guardian()) {
                <p class="text-sm text-gray-400">{{ relationShip() }}</p>
            }
        </div>
        <div class="flex gap-2 items-center">
            <button
                [disabled]="
                    !firstCounseling() ||
                    firstCounseling()?.status === 'PENDING'
                "
                (click)="toggleDocument(firstCounseling()?.id!)"
                [ngClass]="{
                    'border-primary bg-primary-50 text-primary':
                        firstCounseling() &&
                        selectedDocuments()?.includes(firstCounseling()?.id!)!,
                    'border-gray-500 bg-zinc-50 text-gray-500':
                        firstCounseling() &&
                        !selectedDocuments()?.includes(firstCounseling()?.id!)!,
                    'bg-zinc-50 !text-gray-300 !border-gray-300':
                        !firstCounseling() ||
                        firstCounseling()?.status === 'PENDING',
                }"
                class="px-3 py-0.5 rounded-full border flex gap-1 items-center border-gray-500"
            >
                <p class="text-sm">초기 상담지</p>
                <app-icon name="garden:file-pdf-fill-16" class="!size-3" />
            </button>
            <button
                [disabled]="!report() || report()?.status === 'PENDING'"
                (click)="toggleDocument(report()?.id!)"
                [ngClass]="{
                    'border-primary bg-primary-50 text-primary':
                        report() &&
                        selectedDocuments()?.includes(report()?.id!)!,
                    'border-gray-500 bg-zinc-50 text-gray-500':
                        report() &&
                        !selectedDocuments()?.includes(report()?.id!)!,
                    'bg-zinc-50 !text-gray-300 !border-gray-300':
                        !report() || report()?.status === 'PENDING',
                }"
                class="px-3 py-0.5 rounded-full border flex gap-1 items-center border-gray-500"
            >
                <p class="text-sm">중간 보고서</p>
                <app-icon name="garden:file-pdf-fill-16" class="!size-3" />
            </button>
            <button
                [disabled]="!endReport() || endReport()?.status === 'PENDING'"
                (click)="toggleDocument(endReport()?.id!)"
                [ngClass]="{
                    'border-primary bg-primary-50 text-primary':
                        endReport() &&
                        selectedDocuments()?.includes(endReport()?.id!)!,
                    'border-gray-500 bg-zinc-50 text-gray-500':
                        endReport() &&
                        !selectedDocuments()?.includes(endReport()?.id!)!,
                    'bg-zinc-50 !text-gray-300 !border-gray-300':
                        !endReport() || endReport()?.status === 'PENDING',
                }"
                class="px-3 py-0.5 rounded-full border flex gap-1 items-center border-gray-500"
            >
                <p class="text-sm">종료 보고서</p>
                <app-icon name="garden:file-pdf-fill-16" class="!size-3" />
            </button>
        </div>
    </div>
}
